import React from "react";
import { Link } from "react-router-dom";
import { FormControl } from "react-bootstrap";
import Layout from "components/Layout";
import SubmitButton from "components/SubmitButton";
import { calendarsService } from "services";
import { errorFormating } from "utils/utils";
import { withTranslation } from "react-i18next";

class CalendarImports extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			submitted: false,
			errors: {},
			importErrors: [],
			importMessages: [],
			selectedFile: null,
			fileInputKey: 0,
		};
	}

	resetFileInput = () => {
		this.setState((prev) => ({
			selectedFile: null,
			fileInputKey: prev.fileInputKey + 1,
		}));
	};

	async handleDownloadTemplate() {
		const response = await calendarsService.downloadImportTemplate();

		const url = window.URL.createObjectURL(response);
		const a = document.createElement("a");
		document.body.appendChild(a);
		a.href = url;
		a.download = "import_template.xlsx";
		a.click();
	}

	handleImport = async (event) => {
		event.preventDefault();
		this.setState({ isLoading: true });

		if (this.state.selectedFile) {
			try {
				const formData = new FormData();
				formData.append("filename", this.state.selectedFile);

				const response = this.props.system
					? await calendarsService.prepareSystemImport(formData)
					: await calendarsService.prepareImport(formData);

				if (response.ok && !response.has_errors) {
					this.setState(
						{
							isLoading: false,
							errors: {},
							importMessages: [],
							importErrors: [],
						},
						() => {
							if (response.token) {
								this.runImport(response.token);
							}
						}
					);
				} else {
					const importErrors = [];

					// Agregar errores de filas
					if (Array.isArray(response.rows) && response.rows.length > 0) {
						importErrors.push(...response.rows);
					}

					// Agregar errores de cabeceras
					if (response.header && Array.isArray(response.header.errors)) {
						importErrors.push(...response.header.errors);
					}

					this.setState({
						isLoading: false,
						submitted: true,
						errors: response.ok ? {} : { message: "Se ha producido un error" },
						importMessages: [],
						importErrors,
					});
				}
			} catch (error) {
				console.error("Error during import:", error);
				this.resetFileInput();
				this.setState({
					isLoading: false,
					submitted: true,
					importMessages: [],
					importErrors: [],
					errors: {
						message: this.props.t('calendars.imports.errorOccurred'),
					},
				});
			}
		} else {
			this.setState({
				isLoading: false,
				submitted: true,
				importMessages: [],
				importErrors: [],
				errors: {
					message: this.props.t('calendars.imports.noFileSelected'),
				},
			});
		}
	};

	runImport = async (token) => {
		this.setState({ isLoading: true });

		try {
			const response = this.props.system
				? await calendarsService.runSystemImport(token)
				: await calendarsService.runImport(token);

			if (response.ok) {
				this.setState((prev) => ({
					isLoading: false,
					selectedFile: null,
					fileInputKey: prev.fileInputKey + 1,
					errors: {},
					importErrors: response.has_errors ? response.rows || [] : [],
					importMessages: response.rows || [],
				}));
			} else {
				this.setState({
					isLoading: false,
					submitted: true,
					errors: errorFormating(response),
				});
			}
		} catch (error) {
			console.error("Error during import:", error);
			this.resetFileInput();
			this.setState({
				isLoading: false,
				submitted: true,
				importMessages: [],
				importErrors: [],
				errors: {
					message: this.props.t('calendars.imports.errorOccurred'),
				},
			});
		}
	};

	getImportErrors = (rows = [], headerErrors = []) => {
		// Procesar errores de filas
		const rowErrors = rows.map((row, i) => {
			const hasErrors = row.errors && row.errors.length > 0;
			if (!hasErrors) {
				return row.message ? (
					<li key={`row-${i}`}>
						<span className="import-count">{row.message}</span>
					</li>
				) : null;
			}
			return (
				<li key={`row-${i}`}>
					<span className="import-count">{this.props.t('calendars.imports.row', { row: row.row })}</span>
					<ul className="import-details">
						{this.getImportErrorsDetails(row.errors)}
					</ul>
				</li>
			);
		});

		// Procesar errores de cabeceras
		const headerErrorMessages = headerErrors.map((error, i) => (
			<li key={`header-${i}`}>
				<span className="import-header-error">{error.message}</span>
			</li>
		));

		return [...headerErrorMessages, ...rowErrors];
	};

	getImportErrorsDetails = (errors = []) =>
		errors.map((error, i) => (
			<li key={i}>{error.message}</li>
		));

	getImportMessages = (rows = []) =>
		rows.map((row, i) => (
			<li key={i}>
				<span className="import-count">{this.props.t('calendars.imports.row', { row: row.row })}</span>
				<span className="import-text">{row.message}</span>
			</li>
		));

	handleChange = (event) => {
		this.setState({
			selectedFile: event.target.files[0],
		});
	};

	getContent = () => (
		<form key={this.state.fileInputKey} onSubmit={this.handleImport}>
			<ol className="steps">
				<li className="step-download">
					{this.props.t('calendars.imports.step1Part1')}<Link to={this.props.system ? '/calendars-system' : '/calendars'} className="alink">{this.props.t('calendars.imports.step1Link')}</Link>{this.props.t('calendars.imports.step1Part2')}
				</li>
				<li className="step-download">
					{this.props.t('calendars.imports.step2Prefix')}{" "}
					<span
						className="link"
						onClick={() => this.handleDownloadTemplate()}
					>
						{this.props.t('calendars.imports.step2Link')}
					</span>{" "}
					{this.props.t('calendars.imports.step2Suffix')}
				</li>
				<li className="step-upload">
					<div className="step-upload-content">
						{this.props.t('calendars.imports.step3')}
						<FormControl
							type="file"
							onChange={this.handleChange}
							className="form-control"
						/>
					</div>
				</li>
			</ol>
			<SubmitButton
				type="submit"
				isLoading={this.state.isLoading}
				text={this.props.t('calendars.imports.submit')}
				loadingText={this.props.t('calendars.imports.submitting')}
			/>
			{this.props.system && (
				<p className="mt20">{this.props.t('calendars.system.importNotice')}</p>
			)}
		</form>
	);

	render() {
		const { importErrors, importMessages, errors } = this.state;

		return (
			<Layout className="page-imports">
				<div className="heading">
					<div className="heading-left">
						<h1 className="title">{this.props.t(this.props.system ? 'calendars.system.importTitle' : 'calendars.imports.title')}</h1>
					</div>
				</div>

				{this.getContent()}

				{errors.message && importErrors.length === 0 && (
					<p className="error-message">{errors.message}</p>
				)}

				{importErrors.length > 0 && (
					<div className="import-list import-errors">
						<p className="import-list-text">
							Se han encontrado los siguientes errores en la importación:
						</p>
						<ul className="import-rows">
							{this.getImportErrors(
								importErrors.filter((error) => error.row),
								importErrors.filter((error) => !error.row)
							)}
						</ul>
					</div>
				)}

				{importMessages.length > 0 && (
					<div className="import-list import-messages">
						<p className="import-list-text">{this.props.t('calendars.imports.importResult')}</p>
						<ul className="import-rows">
							{this.getImportMessages(importMessages)}
						</ul>
					</div>
				)}
			</Layout>
		);
	}
}

export default withTranslation()(CalendarImports);
